<!-- Navbar -->
<div class="content">
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>Dashboard</h2>
          <!--<p>Overall details</p>-->
          <!--<a href="#" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
                   Back
                 </a>-->
        </div>
      </div>
      <div class="row">
        <!--<div class="col-lg-2 col-sm-3 col-12 " style="margin-top: 11px;">
                  <div class="form-group" >
                  <form enctype="application/x-www-form-urlencoded" role="form" autocomplete="off" >
                    <fieldset>
                      <date-range-picker [options]="" [controlName]="'rightDateRange'" aria-readonly="true"></date-range-picker>
                    </fieldset>
                  </form>
                  </div>
                 </div>-->
        <div class="col-lg-2 col-md-3 col-sm-12">
          <div class="form-group multiple">
            <label for="Species Name">Farm Name</label>
            <select name="farmname" id="farmname" class="form-control selectpicker myFakeClass"
              style="top:40px!important">
              <option *ngFor='let farmlist of getfarmsListData' [value]="farmlist.tnfr_id">{{farmlist.tnfr_name}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-12">
          <div class="form-group">
            <label for="Species Name">Species Name</label>
            <select id="Speciesname" class="selectpicker form-control myFakeClass1"
              (change)="breedselectbyspecies($event)">
              <option *ngFor='let specieslist of speciesloaddata' [value]="specieslist.id">{{specieslist.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-12">
          <div class="form-group">
            <label for="Breed Name">Breed Name</label>
            <select id="BreedName" class="selectpicker form-control myFakeClass2">
              <option *ngFor='let breedname of getspeciesvalue' [value]="breedname.id">{{breedname.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-lg-2 col-sm-3 col-12">
          <div class="form-group">
            <label for="Breed Name">Age</label>
            <select id="age" class="selectpicker form-control myFakeClass3">
              <option *ngFor='let age_data of get_age' [value]="age_data.tnag_id">
                {{age_data.tnag_name}}({{age_data.tnag_time_range}}) </option>
            </select>
          </div>
        </div>
        <div class="col-lg-2 col-sm-3 col-12">
          <div class="form-group">
            <label for="Breed Name"></label>
            <span class="input-group-btn">
              <button class="btn btn-primary" type="button" (click)="get_datas()"><span class="fa fa-search"></span>
                Search</button>
            </span>
          </div>

        </div>
        <div class="col-lg-1 col-sm-3 col-12" style="margin-top: 18px;">
          <div class="form-group">
            <span class="input-group-btn">
              <button class="btn btn-primary" type="button" (click)="exportdata()"><span
                  class="fa fa-download"></span></button>
            </span>
          </div>

        </div>
      </div>
      <div class="row" id="contentToConvert">
        <div class="col-lg-12 col-md-6 col-sm-6">
          <div class="card">
            <!-- <google-chart [title]="chartData.title" [type]="chartData.type" [data]="chartData.data"
              [columns]="chartData.columnNames" [options]="chartData.options" [width]="chartData.width"
              [height]="chartData.height">
            </google-chart> -->
          </div>
        </div>


        <!-- <div class="col-lg-5 col-md-6 col-sm-6">
          <google-chart [title]="Genderchart.title" [type]="Genderchart.type" [data]="Genderchart.data"
            [columns]="Genderchart.columnNames" [options]="Genderchart.options" [width]="Genderchart.width"
            [height]="Genderchart.height">

          </google-chart>
        </div> -->

        <!-- <div class="col-lg-7 col-md-6 col-sm-6">
          <div class="card">
            <google-chart [title]="Deathchart.title" [type]="Deathchart.type" [data]="Deathchart.data"
              [columns]="Deathchart.columnNames" [options]="Deathchart.options" [width]="Deathchart.width"
              [height]="Deathchart.height">

            </google-chart>
          </div>
        </div> -->

        <div class="col-lg-12 col-md-6 col-sm-6">
          <div class="card">
            <!-- <google-chart [title]="Formschart.title" [type]="Formschart.type" [data]="Formschart.data"
              [columns]="Formschart.columnNames" [options]="Formschart.options" [width]="Formschart.width"
              [height]="Formschart.height">
            </google-chart> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>